import type {
  TPerformancePracticeResult,
  TPredicateRecommendationResult,
  TPredikatKinerjaSubmissionStep,
  TWorkBehaviorResult,
} from 'types/kinerja-pelaksanaan'
import type {
  TPenetapanRatingPerilakuKerja,
  TPenetapanRatingPraktikKinerja,
} from 'types/kinerja-ks-pelaksanaan'
import type { StatusPengirimanTypes } from 'app/KinerjaShared/stores/penetapan-predikat-kinerja-store'

export const PENETAPAN_PREDIKAT_KINERJA_STEPS: Record<
  TPredikatKinerjaSubmissionStep,
  {
    order: number
  }
> = {
  NOT_CREATED: { order: 0 },
  SUBMIT_KADIS: { order: 1 },
  SUBMIT_GURU: { order: 2 },
  SUBMIT_BKN: { order: 3 },
}

export const PENETAPAN_PREDIKAT_KINERJA_RATINGS_PRAKTIK_KINERJA: TPenetapanRatingPraktikKinerja[] =
  ['Di Bawah Ekspektasi', 'Sesuai Ekspektasi', 'Di Atas Ekspektasi']

export const PENETAPAN_PREDIKAT_KINERJA_RATINGS_PERILAKU_KERJA: TPenetapanRatingPerilakuKerja[] =
  ['Di Bawah Ekspektasi', 'Sesuai Ekspektasi', 'Di Atas Ekspektasi']

export const PENETAPAN_PREDIKAT_KINERJA: Record<
  TPenetapanRatingPraktikKinerja,
  Record<TPenetapanRatingPerilakuKerja, string>
> = {
  'Di Atas Ekspektasi': {
    'Di Bawah Ekspektasi': 'Kurang',
    'Sesuai Ekspektasi': 'Baik',
    'Di Atas Ekspektasi': 'Sangat Baik',
  },
  'Sesuai Ekspektasi': {
    'Di Bawah Ekspektasi': 'Kurang',
    'Sesuai Ekspektasi': 'Baik',
    'Di Atas Ekspektasi': 'Baik',
  },
  'Di Bawah Ekspektasi': {
    'Di Bawah Ekspektasi': 'Sangat Kurang',
    'Sesuai Ekspektasi': 'Butuh Perbaikan',
    'Di Atas Ekspektasi': 'Butuh Perbaikan',
  },
}

export const PENETAPAN_PREDIKAT_KINERJA_RATING_MAPPING: Record<
  `${TPerformancePracticeResult}-${TWorkBehaviorResult}`,
  TPredicateRecommendationResult
> = {
  'BELOW_EXPECTATION-BELOW_EXPECTATION': 'VERY_BAD',
  'BELOW_EXPECTATION-MEET_EXPECTATION': 'NEED_IMPROVEMENT',
  'BELOW_EXPECTATION-EXCEED_EXPECTATION': 'NEED_IMPROVEMENT',
  'MEET_EXPECTATION-BELOW_EXPECTATION': 'BAD',
  'MEET_EXPECTATION-MEET_EXPECTATION': 'GOOD',
  'MEET_EXPECTATION-EXCEED_EXPECTATION': 'GOOD',
  'EXCEED_EXPECTATION-BELOW_EXPECTATION': 'BAD',
  'EXCEED_EXPECTATION-MEET_EXPECTATION': 'GOOD',
  'EXCEED_EXPECTATION-EXCEED_EXPECTATION': 'VERY_GOOD',
}

export const PRAKTIK_KINERJA_RATING_LABEL: Record<
  TPerformancePracticeResult,
  string
> = {
  BELOW_EXPECTATION: 'Di Bawah Ekspektasi',
  MEET_EXPECTATION: 'Sesuai Ekspektasi',
  EXCEED_EXPECTATION: 'Di Atas Ekspektasi',
}

export const PERILAKU_KERJA_RATING_LABEL: Record<TWorkBehaviorResult, string> =
  {
    BELOW_EXPECTATION: 'Di Bawah Ekspektasi',
    MEET_EXPECTATION: 'Sesuai Ekspektasi',
    EXCEED_EXPECTATION: 'Di Atas Ekspektasi',
  }

export const PREDIKAT_KINERJA_LABEL: Record<
  TPredicateRecommendationResult,
  string
> = {
  VERY_GOOD: 'Sangat Baik',
  GOOD: 'Baik',
  NEED_IMPROVEMENT: 'Butuh Perbaikan',
  BAD: 'Kurang',
  VERY_BAD: 'Sangat Kurang',
}

export const STATUS_PENGIRIMAN_LABEL: Record<StatusPengirimanTypes, string> = {
  SENT: 'Sudah Dikirim',
  NOT_SENT: 'Belum Dikirim',
}
